"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionShipment = exports.Shipment = exports.DialogDescription = exports.DialogContent = exports.ButtonsWrapper = void 0;
var _mui = require("@ori-ui/mui");
const DialogContent = exports.DialogContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  paddingTop: theme.spacing(2),
  paddingBottom: 135,
  [theme.breakpoints.up('lg')]: {
    width: 590
  }
}));
const DialogDescription = exports.DialogDescription = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  padding: theme.spacing(0, 3, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6, 4)
  }
}));
const SubscriptionShipment = exports.SubscriptionShipment = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
});
const ButtonsWrapper = exports.ButtonsWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  position: 'absolute',
  background: theme.palette.background.paper,
  bottom: 0,
  left: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 6)
  }
}));
const Shipment = exports.Shipment = (0, _mui.styled)(_mui.Typography)({
  fontWeight: 'bold'
});